import script from "./object_importantMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./object_importantMessage.vue?vue&type=script&setup=true&lang=js"

import "./object_importantMessage.vue?vue&type=style&index=0&id=3a5e56e4&scoped=true&lang=scss"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5e56e4"]])

export default __exports__